/*
     Title: time API
     Description: time API
     Author: Iqbal Hossain
     Date: 11-January-2022
     Modified: 11-January-2022
*/

export const TIME_API = {
  root: '/api/time',
  fetch_all: 'api/time/fetch-all',
  fetch_by_query: `/api/time/fetch-by-query`,
  fetch_by_id: `/api/time/fetch-by-id`,
  add: `/api/time/add`,
  update: `/api/time/update`,
  delete: `/api/time/delete`,
  delete_by_range: `/api/time/delete-range`
};

/** Change Log
 * 11-Jan-2022(Iqbal): Create (root, fetch_by_query, fetch_by_id, add, update, delete, delete_by_range )
 */
